import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div>
  <se-po-persona-eligibility
    [personaId]="personaId"
    [contextOrgId]="contextOrgId"
    [eligibilityRuleSetIds]="eligibilityRuleSetIds">
  </se-po-persona-eligibility>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class PersonaEligibilityExampleComponent {
  public personaId = 59707602
  public contextOrgId = 59497
  public eligibilityRuleSetIds = ['11ea54ca-f8ed-22d2-a2c7-0ed30e0cae0e']
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-eligibility-example',
  template,
  standalone: false,
})
export class PersonaEligibilityExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public personaId = 59707602
  public contextOrgId = 59497
  public eligibilityRuleSetIds = ['11ea54ca-f8ed-22d2-a2c7-0ed30e0cae0e']
}
